"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminTokenType = exports.AuthLevel = void 0;
/**
 * Required authentication level for a method.
 */
var AuthLevel;
(function (AuthLevel) {
    /**
     * RESTRICTED - User is partially authenticated and may perform verification operations.
     */
    AuthLevel[AuthLevel["RESTRICTED"] = 0] = "RESTRICTED";
    /**
     * LOW - User is authenticated.
     */
    AuthLevel[AuthLevel["LOW"] = 1] = "LOW";
    /**
     * STRONG - User is strongly authenticated.
     */
    AuthLevel[AuthLevel["STRONG"] = 2] = "STRONG";
    AuthLevel[AuthLevel["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(AuthLevel || (exports.AuthLevel = AuthLevel = {}));
/**
 * Type of token required to access the admin endpoint.
 */
var AdminTokenType;
(function (AdminTokenType) {
    /**
     * Not defined - the token type is not defined. Default for non-admin endpoints.
     */
    AdminTokenType[AdminTokenType["INVALID_TOKEN_TYPE"] = 0] = "INVALID_TOKEN_TYPE";
    /**
     * Impersonated token - the token required to be impersonated.
     */
    AdminTokenType[AdminTokenType["IMPERSONATED_TOKEN"] = 1] = "IMPERSONATED_TOKEN";
    /**
     * Agent token - the token required to be a general agent token.
     */
    AdminTokenType[AdminTokenType["AGENT_TOKEN"] = 2] = "AGENT_TOKEN";
})(AdminTokenType || (exports.AdminTokenType = AdminTokenType = {}));
//# sourceMappingURL=RpcMethodInfo.js.map